// extracted by mini-css-extract-plugin
export default {"root":"card_root__QXYhZ"};